import type { FC, PropsWithChildren } from "react";
import React from "react";

import { FetchApiClient } from "@core/ports/http";

import { accountAdminApi, oauthApi } from "@apis/account/api";
import { adminApi, maintenanceApi, playgroundApi } from "@apis/admin/api";
import { billingAdminApi } from "@apis/billing/api";
import { busAdminApi } from "@apis/bus/api";

import { env } from "../../../bootstrap/env.ts";
import type { AuthContextValue } from "../../../shared/contexts/auth/context.ts";
import { AuthContext } from "../../../shared/contexts/auth/context.ts";
import { authStore } from "../state/auth.ts";

interface AuthProviderProps {
  readonly authToken: string;
}

export const AuthProvider: FC<PropsWithChildren<AuthProviderProps>> = ({
  authToken,
  children,
}) => {
  const getToken = (): string => authToken;
  const onUnauthorized = authStore.clearToken;
  const stage = env.STAGE;
  const value: AuthContextValue = {
    api: {
      accountAdmin: new FetchApiClient({
        api: accountAdminApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      admin: new FetchApiClient({
        api: adminApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      billingAdmin: new FetchApiClient({
        api: billingAdminApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      busAdmin: new FetchApiClient({
        api: busAdminApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      maintenance: new FetchApiClient({
        api: maintenanceApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      oauth: new FetchApiClient({
        api: oauthApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      playground: new FetchApiClient({
        api: playgroundApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
    },
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
